module.exports = __webpack_public_path__ + "img/slogan-A.38870549.png";